<div>
    <h3 *ngIf="header">{{header}}</h3>
    <ng-content></ng-content>
</div>